import { Preferences } from "@capacitor/preferences";
import type { ShopCategory } from "@phaser/core/shop/shopTypes";
import { getShopCatalog } from "@phaser/core/shop/shopCatalog";

const EQUIPPED_ITEMS_KEY = "monspot_shop_equipped_items";

type EquippedState = Partial<Record<ShopCategory, string>>;

class ShopEquipManager {
  private equippedByCategory: EquippedState = {};
  private initialized = false;

  async init() {
    if (this.initialized) return;

    const { value } = await Preferences.get({ key: EQUIPPED_ITEMS_KEY });

    if (value) {
      try {
        this.equippedByCategory = JSON.parse(value) as EquippedState;
      } catch {
        this.equippedByCategory = {};
      }
    } else {
      getShopCatalog().forEach((item) => {
        if (item.defaultEquipped) {
          this.equippedByCategory[item.category] = item.id;
        }
      });

      await this.save();
    }

    this.initialized = true;
  }

  isEquipped(category: ShopCategory, itemId: string) {
    return this.equippedByCategory[category] === itemId;
  }

  getEquippedItemId(category: ShopCategory): string | undefined {
    return this.equippedByCategory[category];
  }

  async equip(category: ShopCategory, itemId: string) {
    this.equippedByCategory[category] = itemId;
    await this.save();
  }

  private async save() {
    await Preferences.set({
      key: EQUIPPED_ITEMS_KEY,
      value: JSON.stringify(this.equippedByCategory),
    });
  }
}

export const shopEquipManager = new ShopEquipManager();
